export const CURRENT_VERSION = '2.6.0';
export const CURRENT_VERSION_NAME = 'Runple Schneeberg';

